__turbopack_context__.v({
  "delivery__btn": "DeliveryTitle-module-scss-module__0SLrFW__delivery__btn",
  "delivery__icon": "DeliveryTitle-module-scss-module__0SLrFW__delivery__icon",
  "delivery__link": "DeliveryTitle-module-scss-module__0SLrFW__delivery__link",
  "delivery__textWrapper": "DeliveryTitle-module-scss-module__0SLrFW__delivery__textWrapper",
  "delivery__title": "DeliveryTitle-module-scss-module__0SLrFW__delivery__title",
});
